import * as qs from 'query-string';

// Probably a better way of doing this, but this seems to work
export function paginationParameters(location, page, search) {
  var params = qs.parse(location.search);
  if (params.page || page != 0) {
    params.page = page;
  }
  if (search) {
    params.filter = search;
  }
  if (qs.stringify(params)) {
    window.history.replaceState(null, null, `${location.pathname}?${qs.stringify(params)}`);
  }
}
